export const L10Common = /** @type {const} */ ({
  addVariable: 'Add Variable',
  addNew: 'Add New',
  role: 'Role',
  license: 'License',
  addon: 'Addon',
  team: 'Team',
  dialer: 'Dialer',
  reset: 'Reset',
  searchTeams: 'Search teams',
  select: 'Select',
  selectValue: 'Select a Value',
  close: 'Close',
  clear: 'Clear',
  cancel: 'Cancel',
  connect: 'Connect',
  delete: 'Delete',
  type: 'Type',
  search: 'Search',
  name: 'Name',
  phone: 'Phone',
  email: 'Email',
  microsoftTeams: 'Microsoft Teams',
  fullName: 'Full Name',
  standardViews: 'Standard Views',
  myViews: 'My Views',
  teammatesViews: `Teammates' Views`,
  successMessage: 'Changes saved successfully!',
  you: 'You',
  save: 'Save',
  hi: 'Hi',
  welcome: 'Welcome',
  firstName: 'First Name',
  lastName: 'Last Name',
  company: 'Company',
  continue: 'Continue',
  selectATitle: 'Select Job title',
  back: 'Back',
  noResultsFound: 'No Results Found',
  dataGrid: {
    noRows: 'No rows to display',
    noRowsMatchingFilters: 'No rows match the current filters',
    loadingMore: 'Loading more rows...',
    allRowsLoaded: 'All rows loaded',
    loadMore: 'Load more rows',
    expand: 'Expand',
    collapse: 'Collapse',
    selectAllRows: 'Select all rows',
    selectRow: 'Select row',
    reorderRows: 'Reorder rows',
    reorderRow: 'Reorder row',
    reorderInstructions:
      'Use Arrow keys to choose a position, Enter to drop, or Escape to cancel.',
    reorderLifted: '{{rowId}} lifted. {{instructions}}',
    openRowActions: 'Open row actions',
    sortAscending: 'ascending',
    sortDescending: 'descending',
    sortBy: 'Sort by',
    sortPriority: 'priority',
    sortWithShift: 'Hold Shift to add or change a secondary sort',
    sortingCleared: 'Sorting cleared',
    sortingUpdated: 'Sorting updated',
    manageColumns: 'Manage columns',
    searchColumns: 'Search columns',
    resetColumns: 'Reset columns',
    lockedColumn: 'Locked column',
    addSorting: 'Add sorting',
    addGrouping: 'Add grouping',
    clearSorting: 'Clear sorting',
    clearGrouping: 'Clear grouping',
    removeSorting: 'Remove sorting',
    removeGrouping: 'Remove grouping',
    sortingRule: 'sorting',
    groupingRule: 'grouping',
    moveEarlier: 'Move earlier',
    moveLater: 'Move later'
  },
  click: 'Click',
  other: 'Other',
  meetings: 'Meetings',
  untitledMeeting: 'Untitled Meeting',
  tasks: 'Tasks',
  companyName: 'Company Name',
  startNow: 'Start Now',
  disconnect: 'Disconnect',
  disconnected: 'Disconnected',
  disconnectZoom: 'Disconnect Zoom?',
  goBack: 'Go Back',
  scheduleAMeeting: 'Schedule a Meeting',
  edit: 'Edit',
  noSpecialCharactersAllowed: 'No special characters allowed',
  writeHere: 'Write here',
  member: 'Member',
  organizer: 'Organizer',
  members: 'Members',
  types: 'Types',
  riskScore: 'Risk Score',
  viewInCRM: 'View in CRM',
  viewDeal: 'View Deal',
  scheduler: 'Scheduler',
  uploadImage: 'Upload Image',
  slack: 'Slack',
  hubspot: 'HubSpot',
  salesForce: 'Salesforce',
  marketo: 'Marketo',
  menu: 'Menu',
  removeImage: 'Remove Image',
  dealRisk: 'Deal Risk',
  dealHealth: 'Deal Health',
  nextMeetingExists: 'Next Meeting',
  dealRiskScore: 'Deal Risk Score',
  riskScoreTrend: 'Risk Score Trend',
  healthScore: 'Health Score',
  healthScoreTrend: 'Health Score Trend',
  noTrend: 'No trend',
  duration: 'Duration',
  assign: 'Assign',
  logo: 'Logo',
  from: 'From',
  to: 'To',
  owner: 'Issued to',
  contactOwner: 'Contact Owner',
  helpDocs: 'Help Docs',
  alerts: 'Alerts',
  private: 'Private',
  organization: 'Organization',
  selectUsers: 'Select Users',
  notifications: 'Notifications',
  companies: 'Companies',
  date: 'Date',
  call: 'Call',
  calls: 'Calls',
  more: 'More',
  next: 'Next',
  yesProceed: 'Yes, Proceed',
  saveAndNext: 'Save & Next',
  saveAndCreate: 'Save & Create',
  saveAndApply: 'Save and Apply',
  copyCode: 'Copy Code',
  copyEmail: 'Copy Email',
  copy: 'Copy',
  copied: 'Copied!',
  legend: 'Legend',
  or: 'OR',
  on: 'On',
  off: 'Off',
  add: 'Add',
  public: 'Public',
  sortKeys: 'Sort Keys',
  makePublic: 'Make Public',
  Beta: 'Beta',
  viewDetails: 'View Details',
  meetingDetails: 'Meeting Details',
  savePreferences: 'Save Preferences',
  configure: 'Configure content',
  preview: 'Preview',
  done: 'Done',
  standard: 'Standard',
  my: 'My',
  teamMates: `Teammates'`,
  coaching: 'Coaching',
  scorecard: 'Scorecard',
  systemNotifications: 'System Notifications',
  loadMore: 'Load More',
  teams: 'Teams',
  deleteTeam: 'Delete',
  deleteTeamError: 'Failed to delete team',
  deleteTeamCheck: 'Delete Team(s)?',
  deleteTeamWarning:
    'Once deleted, all the direct team members and all the team activity history associated with this team will be also be deleted.',
  deleteTeamInfoMessage:
    "Direct team members won't be removed from the organization. Their meetings and other data will be preserved.",
  yourTeams: 'Your teams',
  otherTeams: 'Other teams',
  proceed: 'Proceed',
  textCopied: 'Text copied to clipboard',
  copyText: 'Copy to clipboard',
  copyErrorMessage:
    'Unable to copy text to clipboard. This may be due to insufficient copy permissions or clipboard access permissions.',
  seconds: 'seconds',
  licenseNeeded: 'Please upgrade to higher plan to access this feature.',
  allMembers: 'All Members',
  yes: 'Yes',
  no: 'No',
  comingSoon: 'Coming Soon',
  viewMore: 'View More',
  new: 'New',
  disconnectCta: 'Yes, Disconnect',
  share: 'Share',
  update: 'Update',
  updateName: 'Update Name',
  learnHow: 'Learn How',
  submit: 'Submit',
  send: 'Send',
  description: 'Description',
  recommended: 'Recommended',
  dismiss: 'Dismiss',
  learnMore: 'Learn More',
  completed: 'Completed',
  settings: 'settings',
  purchaseLicense: 'Purchase/Assign License',
  configuration: 'Configuration',
  deactivated: 'Deactivated',
  configureCta: 'Configure',
  lastModifiedDate: 'Last Modified Date',
  user: 'User',
  avomaUser: 'Avoma User',
  usage: 'Usage',
  searchUser: 'Search User',
  none: 'None',
  selectFromAvomaUsers: 'Select from Avoma Users',
  howItWorks: 'How it works',
  createdBy: 'Created By',
  modifiedBy: 'Modified By',
  legacy: 'Legacy',
  legacyApiKeyTooltip:
    'This API key was created before scoped access was introduced and uses the previous organization-wide access model.',
  disabledLegacyApiKeyTooltip: 'Please upgrade your plan to continue.',
  apiTokenInvalidIssuedUserTooltip:
    'The issued user for this key no longer has a valid license or is not active.',
  apiTokenOwnerTooltip:
    'For user-scoped keys, only the issued user’s meetings and meetings shared with them are available.',
  apiTokenFullAccessTooltip:
    'Includes all data available under Limited access, plus private meetings.',
  apiTokenUserLimitedAccessTooltip:
    'Excludes private meetings and includes only non-private meetings shared with the issued user, plus meetings where they are a participant or organizer.',
  apiTokenOrganizationLimitedAccessTooltip:
    'Excludes private meetings and includes only organization-visible meetings.',
  scope: 'Scope',
  selectScope: 'Select scope',
  selectOwner: 'Select user to issue to',
  apiTokenScopeRequired: 'Scope is required',
  apiTokenOwnerRequired: 'Issued user is required for user-scoped API keys.',
  apiTokenOwnerHelpText:
    'Select the user this API key will be issued to for user-scoped access. Only licensed active users appear in this list.',
  apiTokenScopeHelpTooltip:
    'Scopes apply only to meetings and related data such as notes. All other APIs continue to function as before.',
  apiTokenScopes: {
    userFull: 'User - full access',
    userNonPrivate: 'User - limited access',
    orgNonPrivate: 'Organization - limited access',
    orgFull: 'Organization - full access'
  },
  apiTokenScopeTags: {
    user: 'User',
    organization: 'Organization',
    fullAccess: 'Full access',
    limitedAccess: 'Limited access'
  },
  apiTokenScopeDescriptions: {
    userFull:
      'Includes all data available under Limited access, plus private meetings.',
    userNonPrivate:
      'Excludes private meetings and includes only non-private meetings shared with the issued user, plus meetings where they are a participant or organizer.',
    orgNonPrivate:
      'Excludes private meetings and includes only organization-visible meetings for licensed users.',
    orgFull:
      'Includes all data available under Limited access, plus private meetings.'
  },
  status: 'Status',
  disable: 'Disable',
  enable: 'Enable',
  enabled: 'Enabled',
  disabled: 'Disabled',
  saveAsDraft: 'Save as Draft',
  alreadyMappedTo: name => `Already mapped to ${name}`,
  optional: 'Optional',
  additionalInformation: 'Additional Information',
  removeBadge: 'Remove Badge',
  confirm: 'Confirm',
  seeDetails: 'See Details',
  undo: 'Undo',
  readOnly: 'Read Only',
  others: 'Others',
  successfullyUpdated: 'Successfully Updated',
  clickToEdit: 'Click to Edit',
  doYouWishToProceed: 'Do you wish to proceed?',
  reconnect: 'Reconnect',
  publicEmailDomains: 'Public email domains',
  saveChanges: 'Save Changes',
  saveChangesTitle: 'Save Changes?',
  saveChangesText: 'Are you sure you want to save the changes?',
  here: 'here',
  openSidebar: 'Open sidebar',
  closeSidebar: 'Close sidebar',
  viewAll: 'View All',
  results: 'results',
  connected: 'Connected',
  provider: 'Provider',
  manage: 'Manage',
  quickSetup: 'Quick Setup',
  view: 'View',
  hide: 'Hide',
  active: 'Active',
  inactive: 'Inactive',
  showMore: 'Show more',
  showLess: 'Show less',
  meetingStatusHostTimeout: silenceTimeout =>
    `The Avoma Assistant waited up to ${silenceTimeout} minutes for the host to join. Because the host did not join within this time, the assistant timed out and recording did not start.`,
  duplicate: 'Duplicate',
  expand: 'Expand',
  collapse: 'Collapse',
  digests: 'Digests',
  systemActor: 'System'
});
